import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client } from '@/api/common';
import type { Reservation } from '@/api/reservations';

type Variables = {
  id: number;
  imageUrl: string;
};

export type DeleteTollImageResponse = {
  data: Reservation;
};

export const useDeleteTollImage = createMutation<
  DeleteTollImageResponse,
  Variables,
  AxiosError
>({
  mutationFn: async (variables) =>
    client({
      url: `v2/internal/partners/reservations/${variables.id}/toll-images`,
      method: 'DELETE',
      data: {
        image_url: variables.imageUrl,
      },
    })
      .then((response) => response.data)
      .catch((err: any) => {
        throw new Error(err.response.data.errors.join(', '));
      }),
});
